export default __webpack_public_path__ + "static/disparities-desktop-30593962dc553e82c0162a607239c578.png";